import React from 'react';
import styled from 'styled-components';
import Title from '../../Components/Text/Title';
import SubTitle from '../../Components/Text/SubTitle';
import * as Scroll from 'react-scroll';

let ScrollLink = Scroll.Link;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 180px;
  padding-bottom: 140px;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 970px;
  position: relative;
  z-index: 10;
  justify-content: center;
  @media (max-width: 1110px) {
    width: 100%;
    padding: 0 20px;
  };
`
const ButtonContainer = styled.div`
  margin-top: 80px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  & > div + div {
    margin-left: 30px;
  }
  @media (max-width: 780px) {
    flex-direction: column;
    & > div + div {
      margin-left: 0px;
      margin-top: 30px;
    }
  };
`
const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 340px;
  height: 50px;
  background-color: #090C32;
  cursor: pointer;
  & > p {
    color: white;
    font-size: 15px;
  }
  & > a {
    & > p {
      color: white;
      font-size: 15px;
    }
  }
  @media (max-width: 380px) {
    width: 100%;
  };
`
const GameFiContainer = ({ language }) => {
  return (
    <Container>
      <SubContainer>
        <Title
          text={'Game-Fi'}
        />
        <SubTitle
          style={{ marginTop: 40 }}
          title={'“Make It FUN FIRST!”'}
          text={
            language === "Korean" ?
            '우리는 게임 시나리오에 최적화된 P2E 개발 환경을 제공합니다. 개발자는 인게임 리워드 API를 이용하여 게임화폐를 발행하고 플레이어의 액션 및 목표 달성에 따라 다양한 리워드 방식을 설정할 수 있습니다. 개발자는 게임 시나리오에 최적화된 블록체인 토큰 경제를 구축할 수 있습니다.'
            :
            'We provide a P2E development environment optimized for game scenarios. Developer can use ingame reward API to issue game currency and set various reward methods according to the player\'s action and goal achievement. Developers can make a blockchain token economy optimized for game scenarios.'
          }
        />
        <ButtonContainer>
          <Button>
            {
              language === "Korean" ?
              <p>인게임 리워드 API 매뉴얼 (BETA)</p>
              :
              <p>In-Game Rewards API</p>
            }
          </Button>
          <Button>
            <ScrollLink
              activeClass="active"
              to={'Contacts'}
              spy={true}
              smooth={true}
              offset={-60}
              duration={500}
            >
              {
                language === "Korean" ?
                <p>개발자 센터</p>
                :
                <p>Developer Center</p>
              }
            </ScrollLink>
          </Button>
        </ButtonContainer>
      </SubContainer>
    </Container>
  )
}

export default GameFiContainer;